module.exports = "/static/Images/es/Six.png";